import TextFieldMUI, { TextFieldProps } from '@material-ui/core/TextField';

export const TextField: React.FC<TextFieldProps> = ({ children, ...rest }) => {
	return <TextFieldMUI {...rest}>{children}</TextFieldMUI>;
};
